import { render, staticRenderFns } from "./screen_reportes_producto_crud.vue?vue&type=template&id=3a9f7ab2"
import script from "./screen_reportes_producto_crud.vue?vue&type=script&lang=js"
export * from "./screen_reportes_producto_crud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports